import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

type CopyFormState = {
    isInCopyingViewMode: boolean;
};

const initialState: CopyFormState = {
    isInCopyingViewMode: false,
};

export const copyFormSlice = createSlice({
    name: "copyForm",
    initialState,
    reducers: {
        enableCopyingViewMode(state) {
            state.isInCopyingViewMode = true;
        },
        disableCopyingViewMode(state) {
            state.isInCopyingViewMode = false;
        },
        initializeCopyingViewMode(state) {
            state.isInCopyingViewMode = initialState.isInCopyingViewMode;
        },
    },
});

export const copyFormSliceActions = copyFormSlice.actions;

export const selectIsInCopyingViewMode = (state: RootState) => {
    return !!state.copyForm.isInCopyingViewMode;
};

export default copyFormSlice.reducer;
